import React from 'react'

const FieldErrorMessage: React.FC = ({ children }) => (
  <div className="mt-3 text-xs text-red-500">{children}</div>
)

export { FieldErrorMessage }
